module.exports = __webpack_public_path__ + "img/avatar.775b7396.png";